import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import ClientReportsTab from "../../../../components/Events/Event/ClientReports";
import {
  createCompanyClientReport,
  deleteCompanyClientReport,
  getCompanyClientReport,
  getCompanyClientReports,
} from "../../../../network/apis/companyPortalClientReports";
import { companyPermissionModules } from "../../../../utils/Constants";
import {
  canAddCompanyModule,
  canDeleteCompanyModule,
} from "../../../../utils/Permissions";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";

const companyClientReportsApi = {
  getList: getCompanyClientReports,
  create: createCompanyClientReport,
  getFile: getCompanyClientReport,
  remove: deleteCompanyClientReport,
};

const CompanyEventClientReportsTab = ({ event }) => {
  const history = useHistory();
  const login = useSelector((state) => state.auth.login);

  const handleForbidden = useCallback(() => {
    history.replace(ROUTE_PATHS.companyEvents);
  }, [history]);

  return (
    <ClientReportsTab
      event={event}
      api={companyClientReportsApi}
      canUpload={canAddCompanyModule(
        companyPermissionModules.manageReports,
        login,
      )}
      canDelete={canDeleteCompanyModule(
        companyPermissionModules.manageReports,
        login,
      )}
      onForbidden={handleForbidden}
    />
  );
};

CompanyEventClientReportsTab.propTypes = {
  event: PropTypes.object,
};

CompanyEventClientReportsTab.defaultProps = {
  event: null,
};

export default CompanyEventClientReportsTab;
